import React, { useEffect, useMemo } from 'react';
import { useTable, useFlexLayout } from 'react-table';
import { COLUMNS } from './tableConstants';
import { finalData } from './utils/transformData';
import { useAppDispatch, useAppSelector } from '../../../../../../redux/hooks';
import { ExecButton } from '../../../../../ui/ExecButton/ExecButton';
import { SpacingCustom } from '../../../../../layout/Spacing/SpacingCustom';
import { addKnowledgeGraph } from './knowledgeGraphDiffForSending.slice';
import { fetchKnowledgeGraphMergePeding } from '../KnowledgeGraphMerge/knowledgeGraphMerge.slice';
import { Loader } from '../../../../../shared/Loader/Loader';
import { FlexBetween } from '../../../../../layout/FlexBetween/FlexBetween';
import { TextCustom } from '../../../../../ui/TextCustom';
import { AbsoluteCenter } from '../../../../../layout/AbsoluteCenter/AbsoluteCenter';
import { removeFile } from '../BlobStorage/fileList.slice';
import { selectorKnowledgeGraph } from './redux/selector';
import { closeModal } from '../../../../Modal/modal.slice';

interface IKnowladgeGraphDiffTablePorps {
    selectedKnowledgeFile: string;
}
export const KnowladgeGraphDiffTable: React.FC<IKnowladgeGraphDiffTablePorps> = ({ selectedKnowledgeFile }) => {

    // const { knowladgeGraphDiffData } = useAppSelector((state: rootState) => state.knowladgeGraphDiff);
    // const { userAndTokenData } = useAppSelector((state: rootState) => state.loginUserAndTokenData);
    // const { knowledgeGraphForSendingData } = useAppSelector((state: rootState) => state.knowledgeGraphForSending);
    // const { knowledgeGraphMergeData, knowledgeGraphMergeError, knowledgeGraphMergeLoading } = useAppSelector((state: rootState) => state.knowledgeGraphMerge);

    const {knowladgeGraphDiff, loginUserAndTokenData, knowledgeGraphForSending, knowledgeGraphMerge} = useAppSelector(selectorKnowledgeGraph)
    const {knowladgeGraphDiffData} = knowladgeGraphDiff;
    const {userAndTokenData} = loginUserAndTokenData;
    const {knowledgeGraphForSendingData} = knowledgeGraphForSending;
    const {knowledgeGraphMergeData, knowledgeGraphMergeError, knowledgeGraphMergeLoading} = knowledgeGraphMerge;


    const columns = useMemo(() => COLUMNS, []);
    const data = useMemo(() => finalData(knowladgeGraphDiffData), [knowladgeGraphDiffData]);



    const dispatch = useAppDispatch();

    // useEffect(()=>{
    //   console.log('MERGE DATA: ', knowledgeGraphMergeData)
    // },[knowledgeGraphMergeData])

    useEffect(() => {
        if (knowledgeGraphForSendingData) {
            dispatch(
                fetchKnowledgeGraphMergePeding({
                    url: `${process.env.REACT_APP_KNOWLEDGE_GRAPH_URL_ROOT}/knowledge_graph/merge/`,
                    token: '',
                    body: knowledgeGraphForSendingData,
                }),
            );

            dispatch(closeModal('aiAnalyzerTableModal'));
        }
    }, [knowledgeGraphForSendingData]);

    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable(
        {
            columns: columns,
            data: data,
        },
        useFlexLayout,
    );

    //   add user unique id to all rows
    useEffect(() => {
        rows.forEach((row) => {
            row.original.user_id = userAndTokenData?.user.uniqueId as string;
        });
    }, [rows, userAndTokenData?.user.uniqueId]);

    const onApplyAndMerge = () => {
        dispatch(
            addKnowledgeGraph({
                metadata: { file_url: `${process.env.REACT_APP_BLOB_STORAGE_URL}/${process.env.REACT_APP_BLOB_STORAGE_CONTAINER}/${selectedKnowledgeFile}` },
                instances: rows.map((row) => row.original),
            }),
        );
        dispatch(removeFile(selectedKnowledgeFile));
    };

    return (
        <>
            <div className="ai-analyzer-table-container">
                <div className="ai-analyzer-table" {...getTableProps()} role="table">
                    <div className="ai-analyzer-table__head" role="rowgroup">
                        {headerGroups.map((headerGroup, idx: number) => (
                            <>
                                <div {...headerGroup.getHeaderGroupProps()} key={idx} className="tr" role="row">
                                    {headerGroup.headers.map((column, idx: number) => (
                                        <div {...column.getHeaderProps()} key={idx} className="th" role="columnheader">
                                            {column.render('Header')}
                                        </div>
                                    ))}
                                </div>
                            </>
                        ))}
                    </div>

                    <div className="ai-analyzer-table__body" {...getTableBodyProps()}>
                        {knowledgeGraphMergeLoading ? (
                            <AbsoluteCenter size={20} top={20}>
                                <Loader width={30} height={30} color="accent-green" label="Getting merged data" />
                            </AbsoluteCenter>
                        ) : (
                            <>
                                {rows.map((row, idx: number) => {
                                    prepareRow(row);
                                    return (
                                        <div {...row.getRowProps()} key={idx} className="tr" role="row">
                                            {row.cells.map((cell, idx: number) => (
                                                <div {...cell.getCellProps()} key={idx} className="td" role="cell">
                                                    {cell.render('Cell')}
                                                </div>
                                            ))}
                                        </div>
                                    );
                                })}
                            </>
                        )}
                    </div>
                </div>
            </div>

            <FlexBetween>
                <TextCustom color="accent-green"></TextCustom>
                <SpacingCustom paddingTop={1.5}>
                    <ExecButton label={'Apply and merge'} iconName={'Edit'} func={() => onApplyAndMerge()} />
                </SpacingCustom>
            </FlexBetween>
        </>
    );
};

// import React, { useEffect, useMemo } from "react";
// import { useTable, useFlexLayout } from "react-table";
// import { COLUMNS } from "./tableConstants";
// import { finalData } from "./utils/transformData";
// import { useAppDispatch, useAppSelector } from "../../../../../../redux/hooks";
// import { rootState } from "../../../../../../redux/store";
// import { ExecButton } from "../../../../../ui/ExecButton/ExecButton";
// import { FlexCenter } from "../../../../../layout/FlexCenter/FlexCenter";
// import { SpacingCustom } from "../../../../../layout/Spacing/SpacingCustom";
// import { addKnowledgeGraph } from "./knowledgeGraphDiffForSending.slice";
// import { closeAiAnalyzerTableModal } from "../../../../Modal/modal.slice";
// import { FixedSizeList } from "react-window";

// interface IKnowladgeGraphDiffTableProps {
//   selectedKnowledgeFile: string;
// }

// export const KnowladgeGraphDiffTable: React.FC<IKnowladgeGraphDiffTableProps> = ({
//   selectedKnowledgeFile,
// }) => {
//   const { knowladgeGraphDiffData } = useAppSelector(
//     (state: rootState) => state.knowladgeGraphDiff
//   );

//   const columns = useMemo(() => COLUMNS, []);
//   const data = useMemo(
//     () => finalData(knowladgeGraphDiffData),
//     [knowladgeGraphDiffData]
//   );
//   const { userAndTokenData } = useAppSelector(
//     (state: rootState) => state.loginUserAndTokenData
//   );

//   const { knowledgeGraphForSendingData } = useAppSelector(
//     (state: rootState) => state.knowledgeGraphForSending
//   );

//   const dispatch = useAppDispatch();

//   useEffect(() => {
//     if (knowledgeGraphForSendingData) {
//       console.log("knowledgeGraphForSendingData: ", knowledgeGraphForSendingData);
//       dispatch(closeAiAnalyzerTableModal());
//     }
//   }, [knowledgeGraphForSendingData]);

//   const {
//     getTableProps,
//     getTableBodyProps,
//     headerGroups,
//     rows,
//     prepareRow,
//   } = useTable(
//     {
//       columns: columns,
//       data: data,
//     },
//     useFlexLayout
//   );

//   //   add user unique id to all rows
// useEffect(()=>{
//   rows.forEach(row=>{
//       row.original.user_id = userAndTokenData?.user.uniqueId as string;
//   })
// },[rows, userAndTokenData?.user.uniqueId])

//   const onApplyAndMerge = () => {
//     dispatch(
//       addKnowledgeGraph({
//         metadata: {
//           file_name: `${process.env.REACT_APP_BLOB_STORAGE_URL}/${process.env.REACT_APP_BLOB_STORAGE_CONTAINER}/${selectedKnowledgeFile}`,
//         },
//         instances: rows.map((row) => row.original),
//       })
//     );
//   };

//   return (
//     <>
//       <div className="ai-analyzer-table-container">
//         <div className="ai-analyzer-table" {...getTableProps()} role="table">
//           <div className="ai-analyzer-table__head" role="rowgroup">
//             {headerGroups.map((headerGroup, idx: number) => (
//               <div
//                 {...headerGroup.getHeaderGroupProps()}
//                 key={idx}
//                 className="tr"
//                 role="row"
//               >
//                 {headerGroup.headers.map((column, idx: number) => (
//                   <div
//                     {...column.getHeaderProps()}
//                     key={idx}
//                     className="th"
//                     role="columnheader"
//                   >
//                     {column.render("Header")}
//                   </div>
//                 ))}
//               </div>
//             ))}
//           </div>

//           {/* Virtuelizovani redovi */}
//         <div className="ai-analyzer-table__body" {...getTableBodyProps()}>
//             <FixedSizeList
//               height={500} // Visina vidljivog dela liste
//               itemCount={rows.length} // Ukupan broj redova
//               itemSize={50} // Visina svakog reda
//               width="100%" // Širina liste
//             >
//               {({ index, style }) => {
//                 const row = rows[index];
//                 prepareRow(row);
//                 return (
//                   <div
//                     {...row.getRowProps({ style })}
//                     className="tr"
//                     role="row"
//                   >
//                     {row.cells.map((cell, idx: number) => (
//                       <div
//                         {...cell.getCellProps()}
//                         key={idx}
//                         className="td"
//                         role="cell"
//                       >
//                         {cell.render("Cell")}
//                       </div>
//                     ))}
//                   </div>
//                 );
//               }}
//             </FixedSizeList>
//           </div>
//         </div>
//       </div>
//       <FlexCenter position="end">
//         <SpacingCustom paddingTop={1.5}>
//           <ExecButton
//             label={"Apply and merge"}
//             iconName={"Edit"}
//             func={() => onApplyAndMerge()}
//           />
//         </SpacingCustom>
//       </FlexCenter>
//     </>
//   );
// };
